module.exports = __webpack_public_path__ + "img/Image_02.d1e73a27.jpg";